
import React, { useState } from 'react';
import { 
  DataGrid, 
  GridToolbar,
  GridActionsCellItem 
} from '@mui/x-data-grid';
import { 
  Paper, 
  Typography, 
  Chip,
  Box, 
  Stack,
  Divider
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Groups2Outlined, InfoOutlined, MaximizeOutlined, Person3, SignalWifiStatusbar4Bar } from '@mui/icons-material';
import { LowPerformanceDialog } from '../Dialogs/LowPerformanceDialog';

const PerformanceStatusChip = ({ status }) => {
  switch(status) {
    case 'High Concern':
      return <Chip icon={<ErrorIcon />} label={status} color="error" />;
    case 'Moderate Concern':
      return <Chip icon={<WarningIcon />} label={status} color="warning" />;
    default:
      return <Chip icon={<CheckCircleIcon />} label={status} color="success" />;
  }
};

const TutorLowPerformance = ({ data }) => {
  


    const [selectedTutor, setSelectedTutor] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const columns = [
    { 
      field: 'fullname', 
      headerName: 'Tutor', 
      width: 200,
      renderCell: (params) => {
        return (
            <strong>{params.value}</strong>
        )
      }
    },
    { 
      field: 'session_count', 
      headerName: 'Sessions', 
      width: 120,
      renderCell: (params) => (
        <Box sx={{ color: params.value < 5 ? 'error.main' : 'text.primary' }}>
          {params.value}
        </Box>
      )
    },
    { 
      field: 'unique_student_count', 
      headerName: 'Students', 
      width: 120,
      renderCell: (params) => (
        <Box sx={{ color: params.value < 10 ? 'error.main' : 'text.primary' }}>
          {params.value}
        </Box>
      )
    },
    { 
      field: 'avg_student_score', 
      headerName: 'Avg Score', 
      width: 120,
      valueFormatter: (params) => {
        if (params === null) {
            return "NA"
        }else {
            return `${params ? Math.round(params.value) : null}%`
        }
      }
    },
    { 
      field: 'performance_status', 
      headerName: 'Status', 
      width: 180,
      renderCell: (params) => (
        <PerformanceStatusChip status={params.value} />
      )
    },
    { 
      field: 'actions', 
      type: 'actions',
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<InfoOutlined />}
          label="View Details"
          onClick={() => handleViewDetails(params.row)}
        />
      ]
    }
    ];

    const handleViewDetails = (tutor) => {
        setSelectedTutor(tutor);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedTutor(null);
    };
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
      <Stack direction={"row"} spacing={2} sx={{display: 'flex', alignItems: 'center'}}>
        <Box>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
          Low-Performing Tutors Report
          <Chip 
            label={`${data && data.length} tutors needing attention`} 
            color="warning" 
            variant="outlined"
            sx={{ ml: 2 }}
          />
        </Typography>
        <Typography variant='body2' color='text.secondary'>
            Show tutors with low submissions
        </Typography>
        </Box>
      </Stack>      
      <Divider />
      </Box>
      
    
      <DataGrid
        rows={data}
        columns={columns}
        components={{ Toolbar: GridToolbar }}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        getRowId={(row) => row.id}
        sx={{
          '& .MuiDataGrid-cell--warning': {
            backgroundColor: 'rgba(255, 165, 0, 0.1)',
          },
          '& .MuiDataGrid-cell--error': {
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
          },
        }}
        getCellClassName={(params) => {
          if (params.field === 'session_count' && params.value < 5) {
            return 'MuiDataGrid-cell--error';
          }
          if (params.field === 'unique_student_count' && params.value < 10) {
            return 'MuiDataGrid-cell--warning';
          }
          return '';
        }}
      />
        
      <LowPerformanceDialog open={dialogOpen} onClose={handleCloseDialog} tutor={selectedTutor} />
      </Box>

  );
};

export default TutorLowPerformance;